"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateRoute = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Identity_1 = require("../../identity/Identity");
var UI_1 = require("../../ui/UI");
var LazyRoute_1 = require("./LazyRoute");
function renderPrivateRoute(user) {
    var loader = UI_1.useUIContext().useLoader({}).loader;
    return function (props) {
        switch (user) {
            case undefined:
                return loader;
            case null:
                return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/" });
        }
    };
}
function PrivateRoute(props) {
    var user = Identity_1.useIdentityContext().user;
    if (user) {
        return react_1.default.createElement(LazyRoute_1.LazyRoute, tslib_1.__assign({}, props));
    }
    var component = props.component, routeProps = tslib_1.__rest(props, ["component"]);
    return react_1.default.createElement(LazyRoute_1.LazyRoute, tslib_1.__assign({}, routeProps, { render: renderPrivateRoute(user) }));
}
exports.PrivateRoute = PrivateRoute;
//# sourceMappingURL=PrivateRoute.js.map